var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form tab-content" },
    [
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          !_vm.disabled
            ? _c(
                "v-layout",
                {
                  attrs: {
                    row: "",
                    "align-end": "",
                    "justify-space-between": "",
                    wrap: ""
                  }
                },
                [
                  _c("input-field", {
                    attrs: {
                      value: "",
                      label: _vm.$t("NewEquipment"),
                      size: "large",
                      inputType: "group"
                    }
                  }),
                  _vm._v(" "),
                  _c("input-field", {
                    staticClass: "splitter-input-field",
                    attrs: {
                      label: _vm.$tc("Label", 1),
                      inputType: "text",
                      size: "45",
                      disabled: _vm.disabled
                    },
                    model: {
                      value: _vm.newSplitterLabel,
                      callback: function($$v) {
                        _vm.newSplitterLabel = $$v
                      },
                      expression: "newSplitterLabel"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "input-field",
                    {
                      attrs: {
                        value: _vm.selectedSplitterMaterial,
                        label: _vm.$tc("Equipment", 1),
                        inputType: "other",
                        size: "45"
                      }
                    },
                    [
                      _c("treeselect", {
                        staticClass: "form-input-select",
                        attrs: {
                          options: _vm.newSplitterMaterialOptions,
                          "load-options": _vm.loadNewSplitterMaterialOptions,
                          normalizer: _vm.normalizer,
                          disabled: _vm.disabled || _vm.networkLevel === null,
                          valueFormat: "object",
                          disableFuzzyMatching: ""
                        },
                        model: {
                          value: _vm.selectedSplitterMaterial,
                          callback: function($$v) {
                            _vm.selectedSplitterMaterial = $$v
                          },
                          expression: "selectedSplitterMaterial"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-2 mr-5",
                      attrs: {
                        disabled:
                          !_vm.newSplitterLabel ||
                          _vm.newSplitterLabel === "" ||
                          !_vm.selectedSplitterMaterial ||
                          _vm.loading,
                        icon: "",
                        "x-small": "",
                        text: "",
                        color: "accent"
                      },
                      on: { click: _vm.addSplitter }
                    },
                    [_c("v-icon", [_vm._v("add_circle")])],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              staticStyle: { "flex-wrap": "nowrap" },
              attrs: { row: "", "align-center": "" }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "mt-1",
                  attrs: {
                    disabled: _vm.loading,
                    icon: "",
                    text: "",
                    "x-small": "",
                    color: "accent"
                  },
                  on: { click: _vm.getObjectSplitters }
                },
                [_c("v-icon", [_vm._v("refresh")])],
                1
              ),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  value: "",
                  label: _vm.$t("ExistingSplitters"),
                  size: "large",
                  inputType: "group"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              staticClass: "splitters-container scroll-fire-fox",
              staticStyle: { position: "relative" },
              attrs: { column: "" }
            },
            [
              _c("splitters-table", {
                attrs: {
                  splitters: _vm.splitters,
                  "splitter-material-options": _vm.allSplitterOptions,
                  disabled: _vm.disabled,
                  loading: _vm.loading,
                  updated: _vm.updateIndex
                },
                on: {
                  "edit-splitter": function($event) {
                    return _vm.editSplitter($event.index, $event.data)
                  },
                  "delete-splitter": _vm.removeSplitter
                }
              }),
              _vm._v(" "),
              _c("loading-spinner", {
                attrs: {
                  active: _vm.loading,
                  "is-full-page": false,
                  height: 40,
                  width: 40,
                  color: "accent",
                  "background-color": "transparent"
                },
                on: {
                  "update:active": function($event) {
                    _vm.loading = $event
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "mt-2", attrs: { row: "", "justify-center": "" } },
            [
              _c(
                "v-icon",
                {
                  staticClass: "pr-1",
                  attrs: { color: "#515358", size: "12" }
                },
                [_vm._v("warning")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "message" }, [
                _vm._v(_vm._s(_vm.$t("TabContentSavingWhileEditing")))
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cdd587a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cdd587a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splitters/SplittersTab.vue
// module id = null
// module chunks = 